module.exports = __webpack_public_path__ + "img/icon_map_shljx_c.9a10a903.png";